var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ss__custom__header__desktop__menu__wrapper"},[_c('div',{class:[
      'ss__custom__header__desktop__menu',
      _vm.menuItemHovered ? 'ss__custom__header__desktop__menu--active' : ''
    ]},_vm._l((_vm.menu),function(item){return _c('div',{key:item.name,on:{"mouseenter":function($event){return _vm.onMouseenter(item, $event)},"mouseleave":_vm.onMouseleave}},[_c('SsDesktopMenuItem',{class:[
          'ss__custom__header__desktop__menu__item',
          item.name === _vm.menuItemHovered ? 'ss__custom__header__desktop__menu__item--hover' : ''
        ],attrs:{"item":item},nativeOn:{"click":function($event){return _vm.onMenuItemClick(item, $event)}}}),(_vm.hovered && _vm.menuItemHovered === item.name)?_c('SafeArea',{attrs:{"mouseX":_vm.mouseX,"mouseY":_vm.mouseY}}):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }